<template>
	<v-container
		fluid
		class="d-flex justify-space-between form-page-gutter flex-wrap flex-md-nowrap flex-lg-nowrap">
		<v-card elevation="0" class="rounded-xl" min-width="30%">
			<v-card-title class="d-flex align-center justify-space-between">
				<div v-if="!isUpdating">New Shipment Group</div>
				<div v-else>Shipment Group {{ shipmentGroup.id }}</div>
				<v-btn
					icon
					v-if="isUpdating"
					color="red"
					:disabled="deleteDisabled"
					:loading="isDeleteLoading"
					@click="deleteShipmentGroup">
					<i class="fas fa-trash-alt"></i>
				</v-btn>
				<v-btn
					v-if="isUpdating"
					color="primary"
					depressed
					rounded
					@click="updateShipmentGroup"
					:loading="isLoading">
					<i class="fas fa-save mr-2"></i>
					Update Group
				</v-btn>
				<v-btn
					v-else
					color="primary"
					depressed
					rounded
					@click="addShipmentGroup"
					:loading="isLoading">
					<i class="fas fa-plane-departure mr-2"></i>
					Add Group
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-container class="d-flex flex-column">
					<v-autocomplete
						rounded
						outlined
						dense
						v-model="shipmentGroup.statusId"
						label="Status"
						:items="statuses"
						item-text="displayName"
						item-value="id"></v-autocomplete>
					<v-autocomplete
						rounded
						outlined
						dense
						v-model="shipmentGroup.typeId"
						label="Type"
						:items="types"
						item-text="displayName"
						item-value="id"></v-autocomplete>
					<v-date-picker
						v-model="shipmentGroup.shipmentDate"></v-date-picker>
				</v-container>
			</v-card-text>
			<v-card-text class="ma-0" v-if="isUpdating">
				<v-container>
					<v-btn
						class="mb-2"
						width="100%"
						color="primary"
						depressed
						rounded
						@click="generateReport"
						:loading="isGenerateLoading">
						<i class="fa-solid fa-download"></i>
						Generate Excel Report
					</v-btn>
				</v-container>
			</v-card-text>
		</v-card>
		<v-card
			class="rounded-xl"
			elevation="0"
			min-width="70%"
			v-if="isUpdating">
			<v-card-text>
				<v-container class="mb-2">
					<shipment-list
						:shipments="shipments"
						:custom-headers="[
							'id',
							'mtlTracking',
							'senderId',
							'receiverId',
							'description',
							'boxWeight',
							'shipmentDate',
							'shipmentStatusId',
							'invoiceId',
						]"></shipment-list>
				</v-container>
				<v-container>
					<v-tabs v-model="tab">
						<v-tabs-slider color="primary"></v-tabs-slider>
						<v-tab>Regular ({{ regularOrders.length }})</v-tab>
						<v-tab>Preorder ({{ preorders.length }})</v-tab>
						<v-tab>On Hold ({{ otherOrders.length }})</v-tab>
					</v-tabs>
					<v-tabs-items v-model="tab" touchless>
						<v-tab-item>
							<v-container
								fluid
								class="d-flex"
								v-for="(order, idx) in regularOrders"
								:key="`order-${order.id}`">
								<order-card
									:order="order"
									:force-mobile="true"
									@handle-event="openDialog"></order-card>
								<order-options
									class="d-none"
									v-model="regularOrders[idx]"
									@delete-event="deleteEvent"
									@handle-event="
										refilterOrders
									"></order-options>
							</v-container>
						</v-tab-item>
						<v-tab-item>
							<v-container
								fluid
								class="d-flex"
								v-for="(order, idx) in preorders"
								:key="`order-${order.id}`">
								<order-card
									:order="order"
									:force-mobile="true"
									@handle-event="openDialog"></order-card>
								<order-options
									class="d-none"
									v-model="preorders[idx]"
									@delete-event="deleteEvent"
									@handle-event="
										refilterOrders
									"></order-options>
							</v-container>
						</v-tab-item>
						<v-tab-item>
							<v-container
								fluid
								class="d-flex"
								v-for="(order, idx) in otherOrders"
								:key="`order-${order.id}`">
								<order-card
									:order="order"
									:force-mobile="true"
									@handle-event="openDialog"></order-card>
								<order-options
									class="d-none"
									v-model="otherOrders[idx]"
									@delete-event="deleteEvent"
									@handle-event="
										refilterOrders
									"></order-options>
							</v-container>
						</v-tab-item>
					</v-tabs-items>
				</v-container>
			</v-card-text>
		</v-card>

		<v-dialog v-model="dialog" max-width="350">
			<order-options
				show-id
				v-model="selectedOrder"
				@delete-event="deleteEvent"
				@handle-event="refilterOrders"></order-options>
		</v-dialog>
	</v-container>
</template>
<script>
import generalMixin from "@/js/general-mixin";
import backendService from "@/services/backend-service";
import eventBus from "@/js/event-bus";
import { OrderType, ShipmentGroupStatus } from "@/js/enum";
import OrderCard from "@/components/OrderCard.vue";
import OrderOptions from "@/components/OrderOptions.vue";
import ShipmentList from "@/components/ShipmentList.vue";
export default {
	name: "ShipmentGroup",
	mixins: [generalMixin],
	components: {
		"order-card": OrderCard,
		"order-options": OrderOptions,
		"shipment-list": ShipmentList,
	},
	data() {
		return {
			dialog: false,
			selectedOrder: null,
			isGenerateLoading: false,
			isGenerateOrderLoading: false,
			isUpdating: false,
			isLoading: false,
			isDeleteLoading: false,
			shipmentStatusId: null,
			shipmentGroup: { shipmentDate: null, statusId: null },
			isApplyAllLoading: false,
			applyAllDialog: false,
			applyAllOptions: {
				btnText: "Yes",
				message: "This action is not revertable!",
				title: "Are you sure you want to apply the same status to all shipment under this group?",
			},

			orders: [],
			tab: null,
		};
	},
	mounted: function () {
		this.shipmentGroup.statusId = this.getIdByEnum(ShipmentGroupStatus.New);
		if (this.$route.params.id) {
			this.getUpdateForm();
		}
	},
	computed: {
		Regular() {
			return this.getIdByEnum(OrderType.Regular);
		},
		PlaceHolder() {
			return this.getIdByEnum(OrderType.PlaceHolder);
		},
		Stale() {
			return this.getIdByEnum(OrderType.Stale);
		},
		Preorder() {
			return this.getIdByEnum(OrderType.Preorder);
		},
		deleteDisabled() {
			return this.shipments.length != 0 && this.orders.length != 0;
		},
		idToOption() {
			return this.$store.getters["idToOption"];
		},
		statuses() {
			if (
				this.$store.getters["dropdownToOptions"] &&
				this.$store.getters["dropdownToOptions"]["shipmentGroupStatus"]
			)
				return this.$store.getters["dropdownToOptions"][
					"shipmentGroupStatus"
				].options;
			return [];
		},
		types() {
			if (
				this.$store.getters["dropdownToOptions"] &&
				this.$store.getters["dropdownToOptions"]["shipmentGroupType"]
			)
				return this.$store.getters["dropdownToOptions"][
					"shipmentGroupType"
				].options;
			return [];
		},
		shipmentStatuses() {
			if (
				this.$store.getters["dropdownToOptions"] &&
				this.$store.getters["dropdownToOptions"]["shipmentStatus"]
			)
				return this.$store.getters["dropdownToOptions"][
					"shipmentStatus"
				].options;
			return [];
		},
		customers() {
			return this.$store.getters["customers"];
		},

		shipments() {
			if (this.shipmentGroup && this.shipmentGroup.id)
				return this.$store.getters["shipments"].filter(
					(e) => e.groupId == this.shipmentGroup.id
				);
			return [];
		},
		regularOrders() {
			return this.orders.filter((e) => e.typeId == this.Regular);
		},
		preorders() {
			return this.orders.filter((e) => e.typeId == this.Preorder);
		},
		otherOrders() {
			return this.orders.filter(
				(e) => e.typeId != this.Regular && e.typeId != this.Preorder
			);
		},
		filter: {
			get() {
				return this.$store.getters["shipmentsInGroupFilter"];
			},
			set(val) {
				this.$store.commit("setShipmentsInGroupFilter", val);
			},
		},
	},
	methods: {
		addShipmentGroup() {
			this.isLoading = true;
			backendService
				.addShipmentGroup(this.shipmentGroup)
				.then((response) => {
					this.shipmentGroup.id = response.data;
					this.shipmentGroup.totalWeight = 0;
					this.shipmentGroup.totalBox = 0;
					this.shipmentGroup.totalValue = 0;
					this.shipmentGroup.totalPallet = 0;
					this.$store.commit("addShipmentGroup", this.shipmentGroup);
					this.timer(1000).then(() => {
						this.isLoading = false;
						this.isUpdating = true;
						this.$router.push({
							name: "ShipmentGroupUpdate",
							params: { id: response.data },
						});
						eventBus.$emit(
							"setSnackbar",
							"Successfully added a new shipment group",
							"success",
							true
						);
					});
				});
		},
		generateReport() {
			this.isGenerateLoading = true;

			backendService
				.generateReportByGroupId(this.shipmentGroup.id)
				.then((response) => {
					var binary = atob(response.data);

					var array = new Uint8Array(binary.length);
					for (var i = 0; i < binary.length; i++) {
						array[i] = binary.charCodeAt(i);
					}

					const url = window.URL.createObjectURL(new Blob([array]));

					const a = document.createElement("a");
					a.href = url;
					a.download = "Report.xlsx";
					document.body.appendChild(a);
					a.click();
					a.remove();

					this.timer(1000).then(() => {
						this.isGenerateLoading = false;
					});
				})
				.catch(() => {
					this.timer(1000).then(() => {
						this.isGenerateLoading = false;
						this.errorSnackbar("Ops! Something is not right");
					});
				});
		},
		generateOrderReport() {
			this.isGenerateOrderLoading = true;
			backendService
				.generateOrderReportByGroupId(this.shipmentGroup.id)
				.then((response) => {
					var binary = atob(response.data);

					var array = new Uint8Array(binary.length);
					for (var i = 0; i < binary.length; i++) {
						array[i] = binary.charCodeAt(i);
					}

					const url = window.URL.createObjectURL(new Blob([array]));

					const a = document.createElement("a");
					a.href = url;
					a.download = "Order Report.xlsx";
					document.body.appendChild(a);
					a.click();
					a.remove();
					this.timer(1000).then(() => {
						this.isGenerateOrderLoading = false;
					});
				});
		},
		getDataText(header, shipment) {
			if (header.value == "id") {
				return shipment.id.toString();
			} else if (header.value == "mtlTracking") {
				return shipment.mtlTracking;
			} else if (header.value == "invoiceId") {
				return shipment.invoiceId.toString();
			} else if (header.value == "senderId") {
				return this.getCustomerName(shipment.senderId);
			} else if (header.value == "receiverId") {
				return this.getCustomerName(shipment.receiverId);
			} else if (header.value == "dateCreated") {
				return this.convertToDate(shipment.dateCreated);
			} else if (header.value == "shipmentDate") {
				return this.convertToDate(shipment.shipmentDate, false);
			} else if (header.value == "description") {
				return shipment.description;
			} else if (header.value == "shipmentStatusId") {
				return this.getOptionName(shipment.shipmentStatusId);
			} else if (header.value == "boxWeight") {
				return `${shipment.totalBox}/${shipment.totalWeight}`;
			} else {
				return "";
			}
		},
		getUpdateForm() {
			this.isUpdating = true;
			this.getShipmentGroupById(this.$route.params.id);
			this.getOrdersByShipmentGroupId(this.$route.params.id);
		},
		getOrdersByShipmentGroupId(shipmentGroupId) {
			backendService
				.getOrdersByShipmentGroupId(shipmentGroupId)
				.then((response) => {
					this.orders = response.data;
				});
		},
		getShipmentGroupById(id) {
			backendService.getShipmentGroupById(id).then((response) => {
				this.shipmentGroup = response.data;
				this.shipmentGroup.shipmentDate = new Date(
					this.shipmentGroup.shipmentDate
				)
					.toISOString()
					.split("T")[0];
			});
		},
		openDialog(order) {
			this.selectedOrder = order;
			this.dialog = true;
		},
		updateShipmentGroup() {
			this.isLoading = true;
			backendService.updateShipmentGroup(this.shipmentGroup).then(() => {
				this.$store.commit("updateShipmentGroup", this.shipmentGroup);
				this.timer(1000).then(() => {
					this.isLoading = false;
					this.$store.dispatch("getShipments");
					eventBus.$emit(
						"setSnackbar",
						"Successfully update shipment group",
						"success",
						true
					);
				});
			});
		},
		deleteShipmentGroup() {
			this.isDeleteLoading = true;
			backendService
				.deleteShipmentGroupById(this.shipmentGroup.id)
				.then(() => {
					this.timer(1000).then(() => {
						this.isDeleteLoading = false;
						this.$router.push({ name: "ShipmentGroupList" });
					});
				});
		},
		deleteEvent(id) {
			this.orders = this.orders.filter((x) => x.id != id);
			this.dialog = false;
			this.selectedOrder = null;
		},
		refilterOrders() {
			this.orders = this.orders.filter(
				(e) => e.shipmentGroupId == this.shipmentGroup.id
			);
		},
	},
	watch: {
		"$route.name": {
			handler: function (name) {
				if (name == "NewShipmentGroup") {
					this.isLoading = false;
					this.isUpdating = false;
					this.shipmentGroup = {
						shipmentDate: null,
					};
				}
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>
